import { createFileRoute } from "@tanstack/react-router"
import CollectionsTimelineCard from "~/components/collections/CollectionsTimelineCard"
import { OverviewPage } from "~/components/design-system/pages"
import { useCollectionContext } from "~/context/CollectionProvider"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand-planning/noos/_layout/timeline")({
  component: RouteComponent,
})

function RouteComponent() {
  const { collections, collectionGroups } = useCollectionContext()
  usePageTracking("NOOS - Timeline")

  return (
    <OverviewPage>
      <CollectionsTimelineCard
        collections={collections}
        collectionGroups={collectionGroups}
        hideTasksAndEvents
      />
    </OverviewPage>
  )
}
